export const numberWithCommas = (number, digit) => {
  var x = parseFloat(number).toFixed(digit)
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}


export const getTextMode = (mode) => {
  switch (mode) {
    case "NORMAL_COLD":
      return "น้ำเย็น (Cold)";
    case "NORMAL_WARM":
      return "น้ำอุ่น (Warm)";
    case "NORMAL_HOT":
      return "น้ำร้อน (Hot)";
    case "DELICATE_COLD":
      return "ผ้าบอบบาง น้ำเย็น (Delicate Cold)";
    case "DELICATE_WARM":
      return "ผ้าบอบบาง น้ำอุ่น (Delicate Warm)";
    case "BLANKETS_COLD":
      return "ผ้าห่ม น้ำเย็น (Blankets Cold)";
    case "HIGH":
      return "ร้อนสูง (High Temp)";
    case "LOW":
      return "ร้อนต่ำ (Low Temp)";
    case "MEDIUM":
      return "ร้อนปานกลาง (Medium Temp)";
    case "DELICATE":
      return "ถนอมผ้า (Delicate)";
    default:
      return "น้ำเย็น (Cold)";
  }
}


export const getTextOption = (option) => {

  switch (option) {
    case "EXTRA_WASH":
      return "เพิ่มรอบซัก (Extra Wash)";

    case "EXTRA_RINSE":
      return "เพิ่มรอบล้าง (Extra Rinse)";

    case "EXTRA_WASH_AND_RINSE":
      return "เพิ่มรอบซักและรอบล้าง (Extra Wash and Extra Rinse)";

    default:
      return "เพิ่มรอบซัก (Extra Wash)";
  }

}



